import React from 'react';
var Loader = function () {
    return (React.createElement("div", { className: "spinner-animation text-center mt-6" },
        React.createElement("div", { className: "lds-roller" },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
};
export default Loader;
//# sourceMappingURL=Loader.js.map